import {Helmet} from "react-helmet";
import {buildHelmetTitle} from "../../../helpers/SeoHelper";
import {useNavigate} from "react-router-dom";
import {useCallback, useEffect, useState} from "react";
import {get_levelAs_for_graph} from "../../../api/levelA";
import {isArrayNullUndefinedOrEmpty} from "../../../services/Validator";
import '@xyflow/react/dist/style.css';
import {ReactFlow} from "@xyflow/react";
import GraphLevelANode from "../../nodes/graphScreen/GraphLevelANode";

export default function GraphScreenContent() {
    // Used in GraphScreen to display global graph of application
    // LevelAs

    // PROPERTIES
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState(null)
    const [nodes, setNodes] = useState([])
    const [edges, setEdges] = useState([])
    const nodeTypes = { levelANode: GraphLevelANode }

    // HOOKS
    // ---- Memorizes a function, preventing it from being redefined on every render, unless its dependencies change.
    const getLevelAsForGraph = useCallback(() => {
        // Perform
        // ---- Loader on and clear potential error
        setIsLoading(true)
        setError(null)
        // ---- Api call
        get_levelAs_for_graph()
            .then((res) => {
                if (!isArrayNullUndefinedOrEmpty(res?.nodes) && !isArrayNullUndefinedOrEmpty(res?.edges)) {
                    // Set nodes for react flow
                    const rfNodes = (res?.nodes ?? []).map((node, index) => ({
                        id: String(node.id),
                        type: "levelANode", // Custom component referenced in properties
                        position: { x: (index % 8) * 240, y: Math.floor(index / 8) * 90 },
                        data: {
                            task: node.task,
                            brevet: node.brevet,
                            slug: node.slug,
                            grade: node.grade,
                            subtheme: node.subtheme,
                        },
                    }));
                    // Set edges for react flow
                    const rfEdges = (res?.edges ?? []).map((edge, index) => ({
                        id: `e-${edge.from}-${edge.to}-${index}`,
                        source: String(edge.from),
                        target: String(edge.to),
                        style: { strokeWidth: 2 },
                    }));
                    setNodes(rfNodes);
                    setEdges(rfEdges);
                    setError(null)
                } else {
                    setError('Error in fetching levelAs from graph')
                }
            }).catch((err) => {
                setError('Error in fetching levelAs from graph')
                console.error(err)
        }).finally(() => {
            setIsLoading(false)
        })
    }, [])
    // ---- At rendering : Get levelAs for global graph
    useEffect(() => {
        getLevelAsForGraph()
    }, [getLevelAsForGraph])

    // BUILD
    return (
        <div className={"animate-appearSlow bg-backgroundLight3 overflow-auto w-full h-[100svh] flex justify-start items-center"}>
            {/** META */}
            <Helmet>
                <title>{buildHelmetTitle('Ummia - Graph')}</title>
            </Helmet>
            <div className={"w-full h-full flex justify-center items-center p-[24px]"}>
                <ReactFlow
                    nodes={nodes}
                    nodeTypes={nodeTypes}
                    edges={edges}
                    fitView />
            </div>
        </div>
    );
}